import {
    Cable,
    Layers,
    MonitorPlay,
    Network,
    Radar,
    Satellite,
    SatelliteDish,
    ServerCog,
    ThermometerSnowflake,
} from "lucide-react";

export const CATEGORIES = [
    {
        slug: "kopfstationstechnik",
        label: "Kopfstationen",
        short: "Kabelkopfstationen von Grundig, Astro, Polytron — und die Müller DHx-Reihe aus eigener Fertigung.",
        tag: "EIGENE FERTIGUNG",
        icon: ServerCog,
        img: "/produkte/dh8-verdrahtet-front.webp",
        imgFit: "contain",
        showCassettes: true,
        dhx: [
            {
                name: "DH8-BASIS",
                img: "/produkte/dh8-basis-closed.webp",
                desc: "Kabelkopfstation mit 8 Kassettenplätzen — modular aufgebaut, individuell bestückt und programmiert.",
            },
            {
                name: "DH4-BASIS",
                img: "/produkte/dh4-basis-closed.webp",
                desc: "Kabelkopfstation mit 4 Kassettenplätzen — die flexible Mittelklasse für kleinere Anlagen.",
            },
            {
                name: "DH2-BASIS",
                img: "/produkte/dh2-twin.webp",
                desc: "Kompakte Kabelkopfstation mit 2 Kassettenplätzen — ideal für Nachrüstung und Einzelobjekte.",
            },
        ],
        intro: [
            "Kabelkopfstationen sind das Herz jeder Gemeinschaftsanlage. Wir vertreiben Kopfstationen namhafter Hersteller — und fertigen die Müller DHx-Reihe selbst: modular, kundenspezifisch bestückt und programmiert. Auf unsere eigene Fertigung — Kopfstationen und Steckkarten — geben wir 4 Jahre Garantie.",
            "Wir liefern auch Kopfstationen anderer Hersteller.",
        ],
        items: [
            { name: "Müller Kopfstationen", desc: "Kabelkopfstationen aus eigener Fertigung — DH8-Basis, DH4-Basis und DH2-Basis, kundenspezifisch bestückt und programmiert." },
            { name: "Müller Einzelumsetzer", to: "/produkte/einzelumsetzer", desc: "Standalone-Umsetzer der Müller-Reihe — hier geht es zur kompletten Übersicht." },
            { name: "ASTRO", desc: "Kopfstationstechnik von Astro — Restposten auf Anfrage." },
            { name: "GRUNDIG SAT Systems", desc: "Kopfstationstechnik von Grundig — Restposten auf Anfrage." },
        ],
    },
    {
        slug: "einzelumsetzer",
        label: "Einzelumsetzer",
        short: "Von AV- und UKW-Modulatoren bis zu Twin- und Quad-Umsetzern mit CI-Steckplatz.",
        tag: "UMSETZER & ENCODER",
        icon: SatelliteDish,
        intro: [
            "Einzelumsetzer für die professionelle Kanalaufbereitung: HDMI-Encoder, DVB-S2-, DVB-T/C- und QAM-Umsetzer sowie AV- und UKW-Modulatoren.",
        ],
        items: [
            { name: "SKU-Twin", sku: "099063", desc: "Twin-Umsetzer, 2x DVB-S/S2 Transponder in DVB-S Transponder 910-2200 MHz, 1x CI", ds: "/datenblaetter/sku-twin.pdf" },            { name: "SKU2-Twin", sku: "099078", desc: "Twin-Umsetzer, 2x DVB-S/S2 Transponder in DVB-S Transponder 910-2200 MHz, 2x CI", ds: "/datenblaetter/sku-twin.pdf" },
            { name: "T2C-QAM", sku: "099064", desc: "Twin-Umsetzer, 2x DVB-T/T2/C-Programmpakete in DVB-C (QAM), 2 unabhängige Kanäle 47-862 MHz, 1x CI" },
            { name: "T2C-QAM-2CI", sku: "099088", desc: "Twin-Umsetzer, 2x DVB-T/T2/C-Programmpakete in DVB-C (QAM), 2 unabhängige Kanäle 47-862 MHz, 2x CI" },
            { name: "T2C-COFDM", sku: "099069", desc: "Twin-Umsetzer, 2x DVB-T/T2/C-Programmpakete in DVB-T (COFDM), 2 unabhängige Kanäle 47-862 MHz, 1x CI" },
            { name: "T2C-COFDM-2CI", sku: "099084", desc: "Twin-Umsetzer, 2x DVB-T/T2/C-Programmpakete in DVB-T (COFDM), 2 unabhängige Kanäle 47-862 MHz, 2x CI" },
            { name: "T2C-DVBS", sku: "099062", desc: "Twin-Umsetzer, 2x DVB-T/T2/C-Programmpakete in DVB-S Transponder 910-2200 MHz, 1x CI" },
            { name: "HDMI4-1Q", sku: "230066", desc: "HDMI Single Encoder, HDMI-Signal in QAM-HD, MPEG 4" },
            { name: "HDMI4-2Q", sku: "230065", desc: "HDMI Twin Encoder, HDMI-Signal in QAM-HD, MPEG 4" },
            { name: "HDMI4-4Q", sku: "233064", desc: "HDMI Quad Encoder, HDMI-Signal in QAM-HD, MPEG 4" },
            { name: "HDMI4-1T", sku: "230079", desc: "HDMI Single Encoder, HDMI-Signal in COFDM, MPEG 4" },
            { name: "HDMI4-2T", sku: "230067", desc: "HDMI Twin Encoder, HDMI-Signal in COFDM, MPEG 4" },
            { name: "HDMI4-4T", sku: "233078", desc: "HDMI Quad Encoder, HDMI-Signal in COFDM, MPEG 4" },
            { name: "HDMI4-1S", sku: "230068", desc: "HDMI Single Encoder, HDMI-Signal in DVB/S, MPEG 4" },
            { name: "HDMI4-2S", sku: "230069", desc: "HDMI Twin Encoder, HDMI-Signal in DVB/S, MPEG 4" },
            { name: "HDMI4-4S", sku: "233070", desc: "HDMI Quad Encoder, HDMI-Signal in DVB/S, MPEG 4" },
            { name: "EM1HD", sku: "099096", desc: "Single-Umsetzer HDMI in QAM oder DVB-T, MPEG 4 / MPEG 2 SD, 30-860 MHz" },
            { name: "S2-QAM", sku: "099046", desc: "Twin-Umsetzer, 2x DVB-S2-Programmpakete in QAM, 2 unabhängige Kanäle 47-862 MHz, 1x CI" },
            { name: "S2-QAM-2CI", sku: "099085", desc: "Twin-Umsetzer, 2x DVB-S2-Programmpakete in QAM, 2 unabhängige Kanäle 47-862 MHz, 2x CI" },
            { name: "S2-QUAD", sku: "099049", desc: "QUAD-Umsetzer, 4x DVB-S2-Programmpakete in QAM, 2 Nachbarkanal-Pärchen 47-862 MHz, 1x CI" },
            { name: "S2-COFDM", sku: "099047", desc: "Twin-Umsetzer, 2x DVB-S2-Programmpakete in DVB-T (COFDM), 2 unabhängige Kanäle 47-862 MHz, 1x CI" },
            { name: "S2-COFDM-2CI", sku: "099083", desc: "Twin-Umsetzer, 2x DVB-S2-Programmpakete in DVB-T (COFDM), 2 unabhängige Kanäle 47-862 MHz, 2x CI" },
            { name: "S2-Q-COFDM", sku: "099077", desc: "Quad-Umsetzer, 4x DVB-S2-Programmpakete in DVB-T (COFDM), 2 unabhängige Kanäle 47-862 MHz, 1x CI" },
            { name: "SDU4-TWIN", sku: "099045", desc: "DVB-S-Twin-Umsetzer, Stereo, 2 DVB-S Signale in 2 TV-Kanäle 47-862 MHz, 1x CI" },
            { name: "TDU3-TWIN", sku: "099041", desc: "DVB-T-Twin-Umsetzer, Stereo, 2 DVB-T Signale in 2 TV-Kanäle 47-862 MHz, 1x CI" },
            { name: "USM3", sku: "027039", desc: "Single-AV-Modulator, Stereo, nachbarkanaltauglich, AV-Signal in TV-Kanal 47-862 MHz" },
            { name: "USMTWIN4", sku: "027043", desc: "Twin-AV-Modulator, Stereo, nachbarkanaltauglich, 2 AV-Signale in 2 TV-Kanäle 47-862 MHz, 2 frei programmierbare Kanäle" },
            { name: "UFM3S", sku: "113002", desc: "FM-Stereo-Modulator" },
            { name: "HR2FM", sku: "128005", desc: "Single-Umsetzer, UKW-Programm in TV-Kanal 47-862 MHz, On-Screen" },
            { name: "HR2FM-TWIN", sku: "128006", desc: "Twin-Umsetzer, 2 UKW-Programme in 2 TV-Kanäle 47-862 MHz, On-Screen" },
        ],
        gallery: {
            title: "Unsere Einzelumsetzer im Detail.",
            items: [
                {
                    src: "/produkte/hdmi4-2qam-teaser.webp",
                    caption: "HDMI4-2QAM — 4× HDMI in QAM, MPEG-4-Umsetzer aus eigener Fertigung.",
                    tall: true,
                },
                {
                    src: "/produkte/sku2-twin.webp",
                    caption: "SKU2-Twin — Twin-Umsetzer, 2× DVB-S/S2 in DVB-S, 2× CI — hier mit CI-Modulen bestückt.",
                    wide: true,
                },
            ],
        },
        galleryTop: true,
        galleryCompact: true,
    },
    {
        slug: "antennenheizung",
        label: "Antennenheizung",
        short: "Heizsysteme für eisfreien Empfang — für Antennen von 85 bis 240 cm.",
        tag: "WETTERSCHUTZ",
        icon: ThermometerSnowflake,
        img: "/produkte/hsa-85.webp",
        gallery: {
            title: "So sitzt die Heizung am Spiegel.",
            items: [
                {
                    src: "/produkte/hsa-steuerung.webp",
                    caption: "HSA-Regelkasten mit Sensor — Montage an der Spiegelrückseite, dauerhaft wetterfest verbaut.",
                    wide: true,
                },
                {
                    src: "/produkte/hsa-heizelement.webp",
                    caption: "Heizelement am Spiegelrand — hält die Ablauftille frei, damit kein Eis staut.",
                },
                {
                    src: "/produkte/spiegel-ohne.webp",
                    caption: "Spiegel ohne Heizung — bei Schnee und Eis gefriert die Fläche schnell zu.",
                },
            ],
        },
        intro: [
            "Heizsysteme für 85-100 cm Antennen und Heizungen für 120-240 cm Antennen — für zuverlässigen, eisfreien Empfang bei Extremwetter.",
        ],
        items: [
            { name: "Heizsysteme für 85-100 cm Antennen", desc: "Nachrüst-Heizsysteme für handelsübliche Spiegel von 85 bis 100 cm Durchmesser." },
            { name: "Heizungen für 120-240 cm Antennen", desc: "Leistungsstarke Heizungen für große Antennen von 120 bis 240 cm Durchmesser." },
        ],
        pdf: {
            url: "/datenblaetter/beheizte_sat_antennen.pdf",
            de: { title: "Beheizte SAT-Antennen — die Übersicht (PDF)", sub: "Alle Heizsysteme und Heizer auf 4 Seiten: passend für Antennen von 85 bis 240 cm." },
            en: { title: "Heated satellite antennas — the overview (PDF)", sub: "All heating systems and heaters on 4 pages: for antennas from 85 to 240 cm. (Content in German)" },
        },
    },
    {
        slug: "antennen",
        label: "Antennen",
        short: "Parabolantennen von 65 bis 240 cm sowie Masterfocus-Antennen.",
        tag: "EMPFANG",
        icon: Satellite,
        img: "/produkte/antennen-mfhaus.webp",
        intro: [
            "Parabolantennen in allen gängigen Größen — vom kompakten Spiegel bis zur großen Profi-Antenne für Großanlagen.",
        ],
        gallery: {
            title: "Die großen Antennen in der Praxis.",
            items: [
                { src: "/produkte/antenne-op180-flachdach.webp", caption: "1,8-m-Antenne mit Standfuß auf dem Flachdach — Speisesystem und Verteilerschrank direkt daneben." },
                { src: "/produkte/antenne-op240-turm.webp", caption: "OP 240 mit Standfuß — großflächiger Empfang auch an anspruchsvollen Standorten." },
            ],
        },
        items: [
            { name: "65-100 cm Antennen", desc: "Kompakte Spiegel für Einzel- und kleinere Mehrteilnehmeranlagen.", img: "/produkte/antenne-op100se.webp", pdf: { url: "/datenblaetter/antenne_se_katalog.pdf", de: { title: "Gibertini-Katalog Serie SE (PDF)" }, en: { title: "Gibertini SE series catalogue (PDF)" } } },
            { name: "125 cm Antennen", desc: "Mittelgroße Antennen mit hoher Ausfallsicherheit.", img: "/produkte/antenne-op125.webp" },
            { name: "150 cm Antennen", desc: "Für anspruchsvolle Empfangssituationen.", img: "/produkte/antenne-op150.webp" },
            { name: "180 cm Antennen", desc: "Große Spiegel für Profi-Umsetzer und schwache Signalwege.", img: "/produkte/antenne-op180.webp", pdf: { url: "/datenblaetter/antenne_op180.pdf", de: { title: "Montageanleitung 1,8-m-Antenne (PDF, Englisch)" }, en: { title: "1.8 m antenna assembly manual (PDF, English)" } } },
            { name: "240 cm Antennen", desc: "Maximale Fläche für Großanlagen und professionelle Empfangssysteme.", img: "/produkte/antenne-op240.webp", pdf: { url: "/datenblaetter/antenne_op240.pdf", de: { title: "Datenblatt OP 240 (PDF)" }, en: { title: "OP 240 datasheet (PDF)" } } },
            { name: "Masterfocus-Antennen", desc: "Hochwertige Masterfocus-Spiegel für höchste Ansprüche.", img: "/produkte/antenne-masterfocus.webp" },
        ],
        pdf: [
            { url: "/datenblaetter/antenne_se_katalog.pdf", de: { title: "Gibertini Antennenkatalog Serie SE (PDF)", sub: "Serie SE auf 2 Seiten: Ausstattung und technische Daten für 75, 85 und 100 cm." }, en: { title: "Gibertini SE series antenna catalogue (PDF)", sub: "SE series on 2 pages: features and technical data for 75, 85 and 100 cm. (Content in German)" } },
            { url: "/datenblaetter/antenne_op180.pdf", de: { title: "1,8-m-Antenne — Montageanleitung (PDF, Englisch)", sub: "Channel Master Type 183: komplette Anleitung für Aufbau und Ausrichtung." }, en: { title: "1.8 m antenna — assembly manual (PDF)", sub: "Channel Master Type 183: complete guide for assembly and alignment." } },
            { url: "/datenblaetter/antenne_op240.pdf", de: { title: "OP 240 — Datenblatt der 240-cm-Antenne (PDF)", sub: "Technische Daten und Maße der Type 243 B auf einer Seite." }, en: { title: "OP 240 — datasheet of the 240 cm antenna (PDF)", sub: "Technical data and dimensions of type 243 B on one page." } },
        ],
    },
    {
        slug: "sat-zf-verteilsysteme",
        label: "SAT-ZF-Verteilsysteme",
        short: "Multischalter & Verteiltechnik von Jultec und Kathrein.",
        tag: "VERTEILTECHNIK",
        icon: Network,
        intro: [
            "SAT-ZF-Verteiltechnik für Mehrteilnehmeranlagen: Multischalter, Verteiler und Verstärker führender Hersteller — für Mehrfamilienhäuser, Hotels und Großobjekte.",
        ],
        items: [
            { name: "Jultec", desc: "SAT-ZF-Verteiltechnik von Jultec." },
            { name: "Kathrein", desc: "Verteiltechnik von Kathrein." },
        ],
        links: [
            {
                to: "/produkte/sat-zf-verteilsysteme#jultec",
                label: "Jultec-Geräte im Überblick ansehen",
                desc: "Übersichtsseite mit Unterseiten: Glasfaserprodukte (Optik), JRM-Multischalter mit Beispielen und das JRS-System.",
            },
            {
                to: "/produkte/sat-zf-verteilsysteme#kathrein",
                label: "KATHREIN-Multischalter im Überblick ansehen",
                desc: "Kathrein Line: Multischalter, Einkabel-Systeme, Kaskaden-Zubehör und Netzverstärker.",
            },
        ],
    },
    {
        slug: "fibre-glas",
        label: "Fibre-Glas Empfangssysteme",
        short: "Optische Signalverteilung über Glasfaser — nahezu dämpfungsfrei bis 10.000 Anschlüsse.",
        tag: "OPTIK & GLASFASER",
        icon: Cable,
        img: "https://images.unsplash.com/photo-1597733336794-12d05021d510?q=80&w=1200&auto=format&fit=crop",
        intro: [
            "Die Universal-LNBs setzen die empfangenen Satellitensignale in digitale Lichtwellen um. Die Übertragung zu den einzelnen Verteilern und Endkomponenten erfolgt über Glasfaserkabel, welches nahezu keine Dämpfung hat (ca. 0,3 dB auf 1 km). Dadurch eignen sich diese LNBs besonders bei Anlagen mit langen Signalwegen.",
        ],
        features: [
            { t: "Revolutionäre Technik", d: "Einzigartige und revolutionäre Empfangs- und Verteiltechnik." },
            { t: "Nahezu verlustfrei", d: "Verlustfreie Übertragung von SAT-, DVB-T- und DAB-Signalen." },
            { t: "Skalierbar", d: "Problemlos erweiterbar bis zu 10.000 Teilnehmeranschlüsse." },
        ],
        groups: [
            {
                title: "JULTEC Glasfaserprodukte",
                text: "Vom Sender am Empfangspunkt bis zum Wandler am Verteiler — JULTEC deckt die komplette Glasfaserkette ab.",
                link: {
                    to: "/produkte/sat-zf-verteilsysteme#glasfaser",
                    label: "Jultec-Glasfasergeräte im Detail ansehen",
                    desc: "Gerätetabellen mit Art.-Nr., Eingängen und Ausgängen für JAO, JOL, JOS und JOM.",
                },
                items: [
                    { name: "JAO Glasfasersender", desc: "Der optische Sender am Empfangspunkt — speist JOS- und JOL-Wandler über Glasfaser.", img: "/produkte/jultec-jao0501c1550.webp" },
                    { name: "JOL Glas-Breitband-Wandler", desc: "Zur Speisung von Einkabelmultischaltern und koaxialen Kaskaden.", img: "/produkte/jultec-jol0102-90a.webp" },
                    { name: "JOL Glas-nach-Quatro-Wandler", desc: "Zur Speisung von Multischaltern und koaxialen Kaskaden.", img: "/produkte/jultec-jol0105-88fr.webp" },
                    { name: "JOS Glas-nach-Einkabel-Wandler", desc: "Für FTTH-Anwendungen — Glasfaser direkt zum Einkabel-Endgerät.", img: "/produkte/jultec-jos0201-16t.webp" },
                    { name: "JOM Glas-nach-Legacy-Wandler", desc: "Für FTTH-Anwendungen — Glasfaser zu klassischen Empfängern.", img: "/produkte/jultec-jom0202t-fr.webp" },
                ],
            },
            {
                title: "KATHREIN SAT optik",
                text: "Optische SAT-Verteilung für große Kabelstrecken — nahezu verlustfrei und störungssicher, mit automatischer Pegelanpassung (AGC) und gängigen SC/APC- und FC/PC-Verbindungen.",
                items: [
                    { name: "KEL 300/W — Wideband-Speisesystem", desc: "Die optische Empfangsquelle der SAT optik am Antennenpunkt.", img: "/produkte/kathrein-kel-300-w.webp", pdf: { url: "/datenblaetter/kathrein_db_kel-300-w.pdf", de: { title: "Datenblatt KEL 300/W (PDF)" }, en: { title: "KEL 300/W datasheet (PDF)" } } },
                    { name: "OSQ 4/T — Optischer Sender CWDM", desc: "Überträgt vier Satellitenpositionen plus Terrestrik über eine einzige Glasfaser.", img: "/produkte/kathrein-osq-4t.webp", pdf: { url: "/datenblaetter/kathrein_db_osq_oeq.pdf", de: { title: "Bedienungsanleitung OSQ 4/T (PDF)" }, en: { title: "OSQ 4/T manual (PDF)" } } },
                    { name: "OEQ 4 / OEQ 4/T — Optische Empfänger", desc: "Quad- und Quattro-Empfänger (CWDM) wandeln das optische Signal zurück in SAT-IF.", img: "/produkte/kathrein-oeq-4t.webp", pdf: { url: "/datenblaetter/kathrein_db_osq_oeq.pdf", de: { title: "Bedienungsanleitung OEQ 4 / OEQ 4/T (PDF)" }, en: { title: "OEQ 4 / OEQ 4/T manual (PDF)" } } },
                    { name: "OVS / OVC — Optische Verteiler", desc: "2-, 4-, 8-, 16- und 32-fach (OVS) sowie kompakte 2-/4fach-Verteiler (OVC).", img: "/produkte/kathrein-ovs-16.webp" },
                    { name: "OAS — Optische Abzweiger", desc: "Zweigen einzelne Signalwege aus der Glasfaserstrecke ab.", img: "/produkte/kathrein-oas-7030.webp" },
                    { name: "OCS — Optische Patchkabel", desc: "SC/APC-Patchkabel in Längen von 1 bis 150 m für saubere Glasfaserstrecken.", img: "/produkte/kathrein-ocs-50.webp" },
                    { name: "ODS — Dämpfungsglieder & Adapter", desc: "Optische Dämpfungsglieder und Simplex-Adapter zur exakten Pegelanpassung.", img: "/produkte/kathrein-ods-10.webp" },
                    { name: "OWDM S2 — Wellenlängenmultiplexer", desc: "Bündelt mehrere Wellenlängen auf einer einzigen Faser.", img: "/produkte/kathrein-owdm-s2.webp" },
                    { name: "OPP 24 & OTS 1 — Verteilraum-Zubehör", desc: "19″-LWL-Patch-Panel und optischer Abschluss für ordentliche Verteilräume.", img: "/produkte/kathrein-opp-24.webp", pdf: { url: "/datenblaetter/kathrein_db_opp-24.pdf", de: { title: "Bedienungsanleitung OPP 24 (PDF)" }, en: { title: "OPP 24 manual (PDF)" } } },
                ],
                link: {
                    to: "https://www.kathrein-ds.com/produkt-kategorie/tv-empfang-verteilung/sat-zf-verteiltechnik/sat-optik/",
                    label: "Kathrein SAT optik auf kathrein-ds.com ansehen",
                    desc: "Die komplette Produktwelt mit technischen Daten und Downloads (externer Link).",
                },
            },
        ],
        pdf: {
            url: "/datenblaetter/jultec_glasprodukte_2024.pdf",
            de: { title: "Jultec Glasfaserprodukte 2024 (PDF)", sub: "Der offizielle Jultec-Flyer: alle Glasfaserprodukte auf 2 Seiten." },
            en: { title: "Jultec fibre optic products 2024 (PDF)", sub: "The official Jultec flyer: all fibre optic products on 2 pages. (Content in German)" },
        },
    },
    {
        slug: "lnb",
        label: "LNB-Empfangskonverter",
        short: "Profi- und Standard-Speisesysteme von Swedish Microwave, Inverto und Invacom.",
        tag: "EMPFANGSTECHNIK",
        icon: Radar,
        intro: [
            "Empfangskonverter für jede Anforderung — vom Profi-Speisesystem bis zum Standard-LNB.",
        ],
        items: [
            { name: "Profispeisesysteme", desc: "Swedish Microwave — Profi-LNBs für höchste Ansprüche." },
            { name: "Standard-Speisesysteme", desc: "Inverto & Invacom — zuverlässige Standard-LNBs." },
            { name: "Blockkonverter", desc: "Swedish Microwave — Blockkonverter für professionelle Umsetzung." },
        ],
    },
    {
        slug: "adapter-multifeed",
        label: "Adapter & Multifeedschienen",
        short: "Multifeedschienen und Adapter für Antennen — für den Empfang mehrerer Satelliten.",
        tag: "ZUBEHÖR",
        icon: Layers,
        intro: [
            "Adapter und Multifeedschienen für Antennen — die Grundlage für Multifeed-Empfang mehrerer Satellitenpositionen an einem Spiegel.",
        ],
        items: [
            { name: "Multifeedschienen", desc: "Aufsatzschienen zur Aufnahme mehrerer LNB an einer Antenne." },
            { name: "Adapter", desc: "Adapter für diverse Antennen- und LNB-Kombinationen." },
        ],
    },
    {
        slug: "infomedia",
        label: "InfoMedia-Player",
        short: "Multimedia-Infokanalsystem für Hotels, Kliniken & Wohnanlagen.",
        tag: "MEDIASYSTEME",
        icon: MonitorPlay,
        intro: [
            "Multimedia-Infokanalsystem — der InfoMedia-Player gibt Powerpoint-Präsentationen sowie MPEG- und DIVX-Dateien wieder und speist sie als Infokanal ins Netz ein.",
        ],
        features: [
            { t: "Powerpoint", d: "Wiedergabe von Power-Point-Multimediadateien wie Texttafeln, Grafiken und Einzelbildern. Speicherung auf der Festplatte des InfoMedia-Players." },
            { t: "Filmwiedergabe", d: "Das Abspielen von MPEG- und DIVX-Dateien." },
            { t: "Web-TV", d: "Wiedergabe von im Internet vorhandenen Web-TV-Sendungen (Format: Windows Mediaplayer)." },
            { t: "Timer", d: "Timer-Software zur Umschaltung zwischen Präsentationsprogramm und MPEG-Programm." },
            { t: "Fernsteuerung", d: "Netzwerkkarte TCP/IP 10/100 Mbit zur Fernprogrammierung des Systems. Programmierung einzelner oder mehrerer Systeme in einem zentral gesteuerten Arbeitsschritt. Automatisches Update durch den zentralen FTP-Server." },
        ],
    },
];

export const findCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
